import React from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const AudioPlayerComponent = ({ audioUrl }) => {
  return (
    <div className="accentify-audio-player" style={{ maxWidth: 500 }}>
      <AudioPlayer
        src={audioUrl}
        showJumpControls={false}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        autoPlayAfterSrcChange={false}
        style={{ borderRadius: 16 }}
      />
    </div>
  );
};

export default AudioPlayerComponent;
